import {Section} from "~/components/Section";   
import {useEffect, useState} from "react";
import {getOrderedSectionFromTableInfo, groupAndOrderBySection} from "~/utils/formatHelper";
import {getData} from "~/api/sections";
import PinImage from '~/img/pin.webp'
import { DbAccess, getToken } from "~/api/token";
import { getInfo } from "~/api/tableInfo";
import { useParams } from "react-router";

function Board() {
    let params = useParams();
    const [groupedItems, setGroupedItems] = useState<GroupedItem[]>([]);

    const formatData = (data: BoardApiType, orderedSections: string[]) => {
        const filteredData = data?.list.filter((item:Item) => item.Section !== "Vorlagen");
        return groupAndOrderBySection(filteredData, orderedSections);
    }


    useEffect(() => {
        (async () => {
            const access: DbAccess = await getToken(params.pin || 'prio');
            const info = await getInfo(access);
            const orderedSections = getOrderedSectionFromTableInfo(info);
            const data = await getData(access);
            setGroupedItems(formatData(data, orderedSections));
        })()
    }, [])

    return (
        <div className={"grid grid-cols-3 lg:grid-cols-6"}>
            <div className={"col-span-3 lg:col-span-1 text-white"}>
                <div className={"mt-12 ml-3"}>
                    <div className="flex items-start">
                        <img src={PinImage} alt="" width={50} className="inline" />
                        <div className="ml-5">
                            <span className="block text-xl font-bold">{import.meta.env.VITE_BOARD_NAME}</span>
                        </div>
                        {groupedItems.length == 0 && <div>
                            <div className="ms-5 arc animate-spin"></div>
                        </div>}
                    </div>
                </div>
                {/*{group} und {board}*/}
            </div>
            <div className={"col-span-4"}>
                {groupedItems.map((item) => (
                    <Section title={item.Section} children={item.children} key={item.Section}/>
                ))}
            </div>
            <div className={"col-span-1"}>
                {/*{isAdmin() && <div className={"bg-white"}>Dies sehen nur Admins</div>}*/}
            </div>
        </div>
    )
}

export const DashboardRoute = {
    element: <Board/>
}